export const Account = {
  Account: {
    fields: {
      hasCompletedFinancingProfile: {
        read(_, { readField }) {
          const { estimatedAnnualIncomeCents } = readField('ownerData') ?? {}
          /** Reading the first business from the field 'businesses' returns a reference,
           * from which we can then read further fields in the same way
           * // https://github.com/apollographql/apollo-client/issues/7459
           */
          const [firstBusiness] = readField('businesses') ?? []

          if (!firstBusiness) {
            return false
          }

          const startDate = readField('startDate', firstBusiness)
          const annualRevenueCents = readField('annualRevenueCents', firstBusiness)
          const businessNaicsCode = readField('businessNaicsCode', firstBusiness)
          return (
            !!startDate &&
            Number.isInteger(annualRevenueCents) &&
            Number.isInteger(estimatedAnnualIncomeCents) &&
            !!businessNaicsCode
          )
        },
      },
      hasCompletedSomeFinancingProfile: {
        read(_, { readField }) {
          const { estimatedAnnualIncomeCents } = readField('ownerData') ?? {}
          const [firstBusiness] = readField('businesses') ?? []

          if (!firstBusiness) {
            return false
          }

          const startDate = readField('startDate', firstBusiness)
          const annualRevenueCents = readField('annualRevenueCents', firstBusiness)
          const businessNaicsCode = readField('businessNaicsCode', firstBusiness)
          return (
            !!startDate ||
            Number.isInteger(annualRevenueCents) ||
            Number.isInteger(estimatedAnnualIncomeCents) ||
            !!businessNaicsCode
          )
        },
      },
      isVdfIntentComplete: {
        read(_, { readField }) {
          const [firstBusiness] = readField('businesses') ?? []

          if (!firstBusiness) {
            return false
          }

          const startDate = readField('startDate', firstBusiness)
          const ownerHouseholdIncomeCents = readField('ownerHouseholdIncomeCents', firstBusiness)
          const businessNaicsCode = readField('businessNaicsCode', firstBusiness)
          return !!startDate && !!ownerHouseholdIncomeCents && !!businessNaicsCode
        },
      },

      ownerData: {
        // The following is necessary because Account `ownerData` which is type Person doesn't have an ID field. This makes it hard for
        // Apollo Client to know when it should and shouldn't update the cache. This allows us to update the cache for Accounts whose IDs
        // are the same.
        // See https://deploy-preview-5677--apollo-client-docs.netlify.app/docs/react/v3.0-beta/caching/cache-field-behavior/#merging-non-normalized-objects
        merge: true,
      },
    },
  },
}
